import { render, staticRenderFns } from "./WflowHistory.vue?vue&type=template&id=cf3d25ea&scoped=true"
import script from "./WflowHistory.vue?vue&type=script&lang=js"
export * from "./WflowHistory.vue?vue&type=script&lang=js"
import style0 from "./WflowHistory.vue?vue&type=style&index=0&id=cf3d25ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3d25ea",
  null
  
)

export default component.exports